<app-entity-info
  [entityType]="'team'"
  [imageUrl]="'assets/images/maintenance/services/TEAMS.svg'" />
